<nav class="navbar navbar-dark bg-dark navbar-expand">
  <div class="container-fluid pl-3">
    <a
      class="navbar-brand eps-logo"
      routerLink="/landing-page"
      *ngIf="canCurrentUserGoToLandingPage && !isCurrentUserAnonymous"
    >
      {{ appTitle }}
      <span class="eps-logo-name">Extended Prototype System</span>
    </a>
    <a
      class="navbar-brand eps-logo"
      *ngIf="isCurrentUserAnonymous || !canCurrentUserGoToLandingPage"
    >
      {{ appTitle }}
      <span class="eps-logo-name">Extended Prototype System</span>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarsExample07"
      aria-controls="navbarsExample07"
      aria-expanded="false"
      aria-label="Toggle navigation"
    ></button>
    <div class="collapse navbar-collapse" id="navbarsExample07">
      <ul class="navbar-nav mr-auto">
        <div *ngIf="!isCaseDefinitionDataLoaded && canGotoDataCollectionForms">
          <li *hasPerm="'READ_CASE_DEFINITION'" class="nav-item">
            <ngx-skeleton-loader
              appearance="line"
              count="1"
              animation="progress"
            ></ngx-skeleton-loader>
          </li>
        </div>
        <div
          *ngIf="
            isCaseDefinitionDataLoaded &&
            !haveOneCaseDefinition &&
            canGotoDataCollectionForms
          "
        >
          <li
            ngbDropdown
            class="nav-item dropdown"
            *hasPerm="'READ_CASE_DEFINITION'"
            container="body"
          >
            <button
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              ngbDropdownToggle
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Cases
            </button>
            <div
              class="animate-dropdown"
              ngbDropdownMenu
              aria-labelledby="navbarDropdown"
            >
              <a
                class="dropdown-item"
                *ngFor="let cd of caseDefinitions"
                [routerLink]="['/cases']"
                [queryParams]="{ case_defn_id: cd.id }"
                >{{ cd.name }}</a
              >
              <a class="dropdown-item" [routerLink]="['/cases']">All Cases</a>
            </div>
          </li>
        </div>
        <div
          *ngIf="
            isCaseDefinitionDataLoaded &&
            haveOneCaseDefinition &&
            canGotoDataCollectionForms
          "
        >
          <li *hasPerm="'READ_CASE_DEFINITION'" class="nav-item">
            <a
              class="nav-link"
              [routerLink]="['/cases']"
              [queryParams]="{ case_defn_id: caseDefinition.id }"
              >{{ caseDefinition.name }}</a
            >
          </li>
        </div>

        <div *ngIf="isNotPrincipal">
          <li *hasPerm="'READ_SURVEY'" class="nav-item">
            <a class="nav-link" routerLink="/forms">Data Collection Forms</a>
          </li>
        </div>
        <div *ngIf="isNotPrincipal">
          <li *hasPerm="'READ_REPORT'" class="nav-item">
            <a
              class="nav-link"
              target="blank"
              href="{{ generateLinkToMetabase() }}"
              >Analytics</a
            >
          </li>
        </div>
      </ul>
      <div *ngIf="userDataLoaded && !isCurrentUserAnonymous" class="">
        <ul class="navbar-nav mr-auto">
          <li>
            <span
              class="w-40 user-inital-avatar circle"
              placement="bottom"
              data-container="body"
              [ngClass]="currUser.color"
              ngbTooltip="{{ currUser.username }}"
              >{{ avatarFirstInitial }}
            </span>
          </li>
          <li ngbDropdown class="nav-item dropdown" container="body">
            <button
              ngbDropdownToggle
              class="nav-link dropdown-toggle"
              id="dropdown07"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ generateDisplayEmail() }}
            </button>
            <div
              ngbDropdownMenu
              class="animate-dropdown"
              aria-labelledby="dropdown07"
            >
              <a class="dropdown-item" routerLink="/profile">My Profile</a>
              <div *hasPerm="'ADMIN'">
                <div class="dropdown-divider"></div>
                <a ngbDropdownItem routerLink="/admin/dashboard"
                  >Admin Dashboard</a
                >
                <div class="dropdown-divider"></div>
              </div>
              <a ngbDropdownItem class="dropdown-item">Help</a>
              <a ngbDropdownItem (click)="logOut()" class="dropdown-item"
                >Log Out</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
